import { environment } from '../../environments/environment';
import { ROUTES } from './sidebar-items';

export const appConfig = {
  environment: environment,
  routes: ROUTES
};
